// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"e4ba4d8c","462":"994eae17","631":"bd36c364","782":"02e10a3e","973":"ab713979"}[chunkId] + ".chunk.css";
};